import React, { FC, ReactNode } from 'react'
import { Modal } from 'react-bootstrap'

import './ModalFooter.scss'

interface Props {
  children?: ReactNode
}

export const ModalFooter: FC<Props> = ({ children }) => (
  <Modal.Footer bsPrefix="modal-dialog-footer">{children}</Modal.Footer>
)
